import React from 'react';
import { Link } from 'react-router-dom';

import SurveyImg from "~/assets/images/survey.png"
import CheckMark from "../CheckMark";

const CompleteSurveyGoal = ({status})=> {

  return (
    <Link className="item-goal" to={"/surveys"}>
      <CheckMark done={status} />
      <div>
        <h5 className={"item-title"}> 1 Completed survey </h5>
        <p>Every day we have new surveys available for you, complete 1 survey and get the points</p>
      </div>
      <img src={SurveyImg} className="icon"/>
    </Link>
  )
}

export default CompleteSurveyGoal;
